import { useCallback } from 'react';
import { useAxios } from 'api/axios';
import { Unit, UnitsParams } from './units.types';

export const useGetUnits = () => {
  const [{ data, loading }, getUnitsReq] = useAxios<{
    result: { data: Unit[]; count: number };
  }>({
    method: 'GET',
  });

  const getUnits = useCallback(
    ({
      filterText = '',
      pageNumber,
      resultSize,
      withSubUnits,
    }: UnitsParams) => getUnitsReq({
        url: `/unit`,
        params: { filterText, pageNumber, resultSize, withSubUnits },
      }),
    [getUnitsReq],
  );

  return {
    data: data?.result?.data,
    loading,
    getUnits,
  };
};
